/**
 * External dependencies
 */
import { useMemo } from "react";

export function useNormalizer(data, normalizer) {
	const normalizedData = useMemo(() => {
		if (!data) {
			return [];
		}
		if (data instanceof Object) {
            return Object.values(data).map(normalizer);
        }
		return data.map(normalizer);
	}, [data, normalizer]);

	return normalizedData;
}
